var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDmd = function SvgDmd(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    vectorEffect: "non-scaling-stroke",
    d: "M25.3333 20V28M25.3333 20C25.6746 20 26.0158 20.1302 26.2761 20.3905L29.8856 24M25.3333 20C24.9921 20 24.6509 20.1302 24.3905 20.3905L20.781 24M18.6667 30.6667H32",
    stroke: "var(--accent)",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    vectorEffect: "non-scaling-stroke",
    d: "M8.33334 16.5V3.40499C8.33334 2.89124 8.72264 2.46107 9.23384 2.40995L18.9005 1.44329C19.4892 1.38442 20 1.8467 20 2.43832V14.1667M8.33334 16.5C8.33334 18.433 6.76634 20 4.83334 20C2.90035 20 1.33334 18.433 1.33334 16.5C1.33334 14.567 2.90035 13 4.83334 13C6.76634 13 8.33334 14.567 8.33334 16.5ZM20 14.1667C20 16.0997 18.433 17.6667 16.5 17.6667C14.567 17.6667 13 16.0997 13 14.1667C13 12.2337 14.567 10.6667 16.5 10.6667C18.433 10.6667 20 12.2337 20 14.1667Z",
    stroke: "var(--accent)",
    strokeWidth: 2
  })));
};
export default SvgDmd;